module.exports = __webpack_public_path__ + "static/media/LOGO_LOGOWANIE.0e42fbf0.png";